const adminUserSharedConstantsAr = {
  newPasswordRule1: 'كلمة المرور يجب أن تكون على الأقل 8 حروف',
  newPasswordRule2: 'كلمة المرور يجب أن تحتوي على حرف كبير وحرف صغير على الأقل',
  newPasswordRule3: 'كلمة المرور يجب أن تحتوي على رقم على الأقل',
  newPasswordRule4: ' كلمة المرور يجب أن تحتوي على حرف خاص على الأقل [,.!@#?]',
  invalidPassword: 'كلمة المرور لا تتوافق مع الشروط ادناه',
  invalidConfirmPassword: 'كلمتا المرور ليستا متطابقتان',
  invalidEmail: 'الرجاء إدخال بريد الكتروني صحيح',
  emailUsed: 'البريد الالكتروني مستخدم بالفعل',
  emptyPassword: 'الرجاء إدخال كلمة المرور',
  emptyConfirmPassword: 'الرجاء تأكيد كلمة المرور',
  emptyEmail: 'الرجاء إدخال البريد الالكتروني',
  emptyFirstName: 'الرجاء إدخال الاسم الاول',
  emptyLastName: 'الرجاء إدخال اسم العائلة',
  emptyUserRole: 'الرجاء اختيار وظيفة المستخدم',
  invalidOldPasswordNewPassword: 'كلمة المرور الجديدة لا يمكن أن تكون مطابقة لكلمة المرور القديمة',
  adminUserPermissionEdit: 'تعديل',
  adminUserPermissionDelete: 'حذف',
  adminUserPermissionView: 'عرض',
};

export default adminUserSharedConstantsAr;
